module.exports = __webpack_public_path__ + "img/0-64.42871faf.jpg";